import { jsx as _jsx } from "react/jsx-runtime";
// -------------------------------------------------------
// NOTE: This is a generated file, do not manually modify!
// -------------------------------------------------------
import { SvgIcon } from '@mui/material';
const paths = [
    'M6.33757 7.80082L9.09797 5.0826C9.2081 4.97247 9.38619 4.97247 9.49633 5.0826L9.6627 5.24898C9.77283 5.35911 9.77283 5.5372 9.6627 5.64733L7.26551 8L9.66036 10.3527C9.77049 10.4628 9.77049 10.6409 9.66036 10.751L9.49398 10.9174C9.38385 11.0275 9.20576 11.0275 9.09562 10.9174L6.33522 8.19918C6.22743 8.08905 6.22743 7.91095 6.33757 7.80082Z',
];
export const AngleLeft = (props) => (_jsx(SvgIcon, Object.assign({ viewBox: "0 0 16 16" }, props, { children: paths.map((pathString, i) => (_jsx("path", { d: pathString }, i))) })));
AngleLeft.iconCategory = 'ui';
